import { useEffect } from 'react';

const useBackgroundColorClass = (bgClass, defaultClass = 'bg-background') => {
  useEffect(() => {
    document.body.classList.remove(defaultClass);
    document.body.classList.add(bgClass);

    return () => {
      document.body.classList.add(defaultClass);
      document.body.classList.remove(bgClass);
    };
  }, [bgClass, defaultClass]);
};
export default useBackgroundColorClass;
